var ApiStatus;
(function (ApiStatus) {
    ApiStatus[ApiStatus["OK"] = 200] = "OK";
    ApiStatus[ApiStatus["BAD_REQUEST"] = 400] = "BAD_REQUEST";
    ApiStatus[ApiStatus["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    ApiStatus[ApiStatus["FORBIDDEN"] = 403] = "FORBIDDEN";
    ApiStatus[ApiStatus["CONFLICT"] = 409] = "CONFLICT";
    ApiStatus[ApiStatus["TOO_MANY_REQUESTS"] = 429] = "TOO_MANY_REQUESTS";
    ApiStatus[ApiStatus["INTERNAL_SERVER_ERROR"] = 500] = "INTERNAL_SERVER_ERROR";
    ApiStatus[ApiStatus["FORBIDDEN_HCP_ACCOUNT"] = 18] = "FORBIDDEN_HCP_ACCOUNT";
    ApiStatus[ApiStatus["ANDROID_INTEGRITY_ERROR"] = 40] = "ANDROID_INTEGRITY_ERROR";
    ApiStatus[ApiStatus["LOCKOUT"] = 9] = "LOCKOUT";
    ApiStatus[ApiStatus["API_ERROR"] = 1] = "API_ERROR";
    ApiStatus[ApiStatus["SESSION_MANAGEMENT_ERROR"] = 20] = "SESSION_MANAGEMENT_ERROR";
    ApiStatus[ApiStatus["PATIENT_EXISTS"] = 2] = "PATIENT_EXISTS";
    ApiStatus[ApiStatus["PASSWORD_VALIDATION"] = 4] = "PASSWORD_VALIDATION";
    ApiStatus[ApiStatus["UNSUPPORTED_COUNTRY"] = 6] = "UNSUPPORTED_COUNTRY";
    ApiStatus[ApiStatus["WRONG_REGION"] = 5] = "WRONG_REGION";
})(ApiStatus || (ApiStatus = {}));
export default ApiStatus;
